import { ButtonHTMLAttributes, ReactNode } from "react";
import { AiOutlineLoading } from "react-icons/ai";

interface Props extends Omit<
  ButtonHTMLAttributes<HTMLButtonElement>,
  "type" | "children"
> {
  text: ReactNode;
  type?: "primary" | "muted" | "transparent";
  btnType?: ButtonHTMLAttributes<HTMLButtonElement>["type"];
  isLoading?: boolean;
  LeftIcon?: ReactNode;
}

const variants = {
  primary: "bg-bblue text-white enabled:hover:bg-[#365EAF]",
  muted: "border border-[#9099A8] bg-[#E4E6EA] text-[#9099A8]",
  transparent:
    "border border-bblue bg-transparent text-bblue enabled:hover:bg-blue-100",
};

export default function EnterpriseButton({
  text,
  type = "primary",
  btnType = "submit",
  isLoading = false,
  disabled = false,
  LeftIcon,
  className = "",
  ...props
}: Props) {
  return (
    <button
      {...props}
      type={btnType}
      disabled={disabled || isLoading || type === "muted"}
      className={`relative flex h-8 items-center justify-center rounded-md px-3 py-1 font-SatoshiM font-medium text-base leading-6 tracking-[-0.02em] transition-colors disabled:cursor-not-allowed focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-bblue ${variants[type]} ${className}`}
    >
      {isLoading && (
        <AiOutlineLoading
          aria-hidden="true"
          className="absolute h-4 w-4 animate-spin"
        />
      )}

      <span
        className={`flex items-center justify-center gap-3 ${
          isLoading ? "opacity-0" : ""
        }`}
      >
        {LeftIcon && <span aria-hidden="true">{LeftIcon}</span>}
        {text}
      </span>
    </button>
  );
}
